import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-purpl-table-feedback',
  templateUrl: './purpl-table-feedback.component.html',
  styleUrls: ['./purpl-table-feedback.component.scss'],
})
export class PurplTableFeedbackComponent implements OnInit {
  @Input() label?: string;
  @Input() feedback_status?: string;

  @Output() onResolveRating: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
